export default "__VITE_ASSET__bkSdRkp4__"